var CtlSoInformationController = (function () {
    function CtlSoInformationController(topic, Dialog, env, moment) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.env = env;
        this.moment = moment;
        this.comp = 'ctl_so';
    }
    CtlSoInformationController.prototype.$onInit = function () {
        this.data = {};
        this.readModel = {};
        this.editModel = {};
        this.billingFrequencyOptions = [
            {
                key: 'A', value: 'Annual'
            },
            {
                key: 'M', value: 'Month'
            },
            {
                key: 'U', value: 'Upfront'
            }
        ];
        if (this.topic && this.topic.topic.ctl_so) {
            this.data.lengthOfTerm = this.topic.topic.ctl_so.lengthOfTerm;
            this.data.billingFrequency = this.topic.topic.ctl_so.billingFrequency;
            this.data.startDate = this.topic.topic.ctl_so.startDate;
            this.data.billingDate = this.topic.topic.ctl_so.billingDate;
        }
        this.restoreEditModel();
        this.edit = this.topic.getEditComponent(this.comp);
        this.canClickButton(); // Set who can click the Submit and Edit buttons
        this.syncReadModel();
    };
    CtlSoInformationController.prototype.syncReadModel = function () {
        var _this = this;
        this.readModel.lengthOfTerm = this.data.lengthOfTerm ? String(this.data.lengthOfTerm) : '-';
        this.readModel.billingFrequencyLabel = this.billingFrequencyOptions.filter(function (opt) { return opt.key === _this.data.billingFrequency; }).map(function (opt) { return opt.value; }).pop() || '-';
        var monDiff = this.diffInMonths(this.data.startDate, this.data.billingDate, true);
        this.readModel.billingMonth = monDiff ? String(monDiff) : '-';
    };
    CtlSoInformationController.prototype.inlineDataWithUI = function () {
        this.data.lengthOfTerm = this.editModel.lengthOfTerm || undefined;
        this.data.billingFrequency = this.editModel.billingFrequency || undefined;
        this.data.startDate = this.formatDate(this.startDate);
        this.data.billingDate = this.formatDate(this.billingDate);
        return this.data;
    };
    CtlSoInformationController.prototype.restoreEditModel = function () {
        this.editModel.lengthOfTerm = this.data.lengthOfTerm || undefined;
        this.editModel.billingFrequency = this.data.billingFrequency || undefined;
        this.editModel.startDate = this.data.startDate; //this.formatDate(this.startDate);
        this.editModel.billingDate = this.data.billingDate; //this.formatDate(this.billingDate);
        this.startDate = this.toDate(this.data.startDate);
        this.billingDate = this.toDate(this.data.billingDate);
    };
    CtlSoInformationController.prototype.diffInMonths = function (dateValueFrom, dateValueTo, includedBorder) {
        if (!dateValueFrom || !dateValueTo) {
            return undefined;
        }
        var momFrom = this.moment.utc(dateValueFrom, CtlSoInformationController.BILLING_DATE_FORMAT);
        var momTo = this.moment.utc(dateValueTo, CtlSoInformationController.BILLING_DATE_FORMAT);
        var diffInMonths = (momTo.format('YYYY') - momFrom.format('YYYY')) * 12
            + (momTo.format('MM') - momFrom.format('MM'));
        if (diffInMonths < 0) {
            return undefined;
        }
        return diffInMonths + (includedBorder ? 1 : 0);
    };
    CtlSoInformationController.prototype.canClickButton = function () {
        this.canClick = false;
        // If user is bpso admin or system admin
        if (this.env.user.access.bpsoAdmin ||
            this.env.user.access.systemAdmin) {
            this.canClick = true; // Enable submit and refresh buttons
        }
    };
    CtlSoInformationController.prototype.showErrorDlg = function (msg) {
        var items = {
            icon: 'ERROR',
            message: msg,
            title: 'Saving Error'
        };
        this.Dialog.updateValidForm(undefined, items, 'confirm-prompt.html').then(function (dResult) {
            return;
        });
    };
    CtlSoInformationController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            var hasError = !!this.termError || !!this.billingError || !!this.frequencyError;
            if (hasError) {
                this.showErrorDlg('Please, fix incorrect CTL SO fields.');
                return;
            }
            if (this.topic.updatePartialSocketStatus([this.comp], 'Updating')) {
                this.inlineDataWithUI();
                var updateObject = {
                    data: {
                        ctl_so: {
                            add: true,
                            data: this.data
                        }
                    },
                    editOption: undefined,
                    id: this.topic.topic._id,
                    type: ['ctl_so']
                };
                this.topic.updateServerTopic('couchUpdate', updateObject, true);
                this.syncReadModel();
                this.edit.editMode = this.topic.cancelEdit(this.comp);
            }
        }
        else if (action === 'edit') {
            if (this.topic.temp.status.status_no !== 4 || !this.topic.getEditComponent('ctl_so')) {
                this.showErrorDlg('It is not allowed to edit CTL SO at the current stage.');
                return;
            }
            this.restoreEditModel();
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.restoreEditModel();
            this.syncReadModel();
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        this.onChange();
    };
    CtlSoInformationController.prototype.formatDate = function (date) {
        return date ? this.moment(date).format(CtlSoInformationController.BILLING_DATE_FORMAT) : undefined;
    };
    CtlSoInformationController.prototype.toDate = function (dateStr) {
        return dateStr ? this.moment(dateStr, CtlSoInformationController.BILLING_DATE_FORMAT).toDate() : undefined;
    };
    CtlSoInformationController.prototype.onChange = function () {
        this.checkTerm();
        this.checkFrequency();
        this.checkBillingDates();
    };
    CtlSoInformationController.prototype.checkTerm = function () {
        this.termError = this.editModel.lengthOfTerm ? '' : "* 'Length of term' is invalid.";
    };
    CtlSoInformationController.prototype.checkFrequency = function () {
        this.frequencyError = this.editModel.billingFrequency ? '' : "* 'Billing frequency' is invalid.";
    };
    CtlSoInformationController.prototype.checkBillingDates = function () {
        var err = '';
        if (angular.isUndefined(this.startDate) || this.startDate === null || !angular.isDate(this.startDate)) {
            err = "* Please enter 'Start Date'<br>";
        }
        if (angular.isUndefined(this.billingDate) || this.billingDate === null || !angular.isDate(this.billingDate)) {
            err += "* Please enter 'Billing Date'";
        }
        if (!err) {
            var range = Math.round(this.billingDate - this.startDate);
            if (range < 0) {
                err = '* The Start/Billing Date range is invalid.';
            }
        }
        this.billingError = err;
    };
    CtlSoInformationController.$inject = ['topic', 'Dialog', 'env', 'moment'];
    CtlSoInformationController.BILLING_DATE_FORMAT = 'YYYYMMDD';
    return CtlSoInformationController;
}());
var CtlSoInformationComponent = (function () {
    function CtlSoInformationComponent() {
        this.templateUrl = 'ctl-so-information.html';
        this.controllerAs = 'vm';
        this.controller = CtlSoInformationController;
    }
    return CtlSoInformationComponent;
}());
angular
    .module('application')
    .component('ctlSoInformation', new CtlSoInformationComponent());

//# sourceMappingURL=ctl.so.information.component.js.map
